"use strict";
/**
 *
 * Script to show a hiden target (a gravity form HTML field with the class .hide) and then scroll smoothly to it.
 *
 * The target is defined using the following attribute data-show-and-scroll-to="ID_of_target"
 * Example:
 *
 * <a data-show-and-scroll-to="#results1"> This link will scrolls to an element with the id="results1" and then slideDown to reveal its parent.
 *
 */
function showHidenTargetAndScrollToIt(trigger, elementIdToHide) {
    var destination = jQuery(trigger.attr('data-show-and-scroll-to'));
    var destinationParent = destination.parent();
    if (trigger.hasClass('disabled')) {
        trigger.addClass('animated shake');
        setTimeout(function () {
            trigger.removeClass("animated shake");
        }, 800);
    }
    else {
        // Hiding the results
        jQuery(elementIdToHide).hide();
        if (destination.is(':visible')) {
            destinationParent.addClass('animated fadeIn');
            setTimeout(function () {
                destinationParent.removeClass("animated fadeIn");
            }, 800);
        }
        else {
            destinationParent.slideDown();
        }
        jQuery('html,body').animate({
            scrollTop: (destination.offset().top - 110)
        }, 500);
    }
}
(function ($) {
    $(document).ready(function () {
        if ($('[data-show-and-scroll-to]').length > 0) {
            $('[data-show-and-scroll-to]').click(function (e) {
                e.preventDefault();
                var elementIdToHide = $(this).attr('data-hide-element');
                showHidenTargetAndScrollToIt($(this), elementIdToHide);
            });
        }
    });
})(jQuery);
